import ConnectionService, { HttpMethod } from './connection.service';
import { IRelease, IReleaseMarker } from '../../models/release.model';

class ReleaseConnection {
  public async getReleases(data?: object): Promise<{releases: IRelease[]}> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/releases`, HttpMethod.GET, data);
  }

  public async getMarkers(data: object): Promise<IReleaseMarker[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/releases/markers`, HttpMethod.GET, data);
  }
}

export default new ReleaseConnection();
